import React from "react"
import { connect } from "react-redux"
import { withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import CircularProgress from '@material-ui/core/CircularProgress'
//import { I18n } from 'react-redux-i18n'

import Appointment from './Appointment'
import PrivateAppointment from './PrivateAppointment'
import NoAppointment from './NoAppointment'
import {getAppointmentByDate} from './../../../actions/appointmentActions'
import {deleteAppointment} from './../../../actions/deleteAppointmentActions'

const styles = theme => ({
  list: {
    padding: 0,
    position: 'relative',
    overflow: 'hidden'
  },
  center: {
    paddingTop: 10,
    textAlign: 'center',
    width: '100%'
  }
})

class AppointmentList extends React.Component {
  componentDidMount(){
    this.props.dispatch(getAppointmentByDate(this.props.date.format('YYYYMMDD')))
  }

  componentWillUpdate(nextProps){
    if(this.props.date !== nextProps.date){
      this.props.dispatch(getAppointmentByDate(nextProps.date.format('YYYYMMDD')))
    }
  }

//krijg de hik, kutreact
  deleteAppointmentEvent = (id) => {
    this.props.dispatch(deleteAppointment(id))
  }

  render(){
    if(this.props.appointment.appointmentsFetched){
      return(
        <List dense={false} className={this.props.classes.list}>
          {this.props.appointment.appointments.length === 0 ?
            (
              <NoAppointment
                key='1'
                fromTime={"07:00"}
                toTime={"18:00"}
                selectedDate={this.props.date}
                />
            )
            :
            this.props.appointment.appointments.map((appointment, index) => (

                (appointment.prive && this.props.otherUser.loggedIn) ? (
                  <PrivateAppointment
                    key={appointment.id}
                    appointment={appointment}
                    selectedDate={this.props.date} />
                ) : (

                  (appointment.id===0)?(
                    <NoAppointment
                      key={index}
                      appointment={appointment}
                      selectedDate={this.props.date}
                      />

                  ):(
                    <Appointment
                      key={appointment.id}
                      appointment={appointment}
                      deleteAppointment={this.props.deleteAppointment}
                      deleteAppointmentEvent={this.deleteAppointmentEvent}
                      selectedDate={this.props.date} />
                  )
                )

            )

            )
          }

        </List>
      )
    }

    return (
      <div className={this.props.classes.center}>
        <CircularProgress/>
      </div>
    )

  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  appointment: state.appointment,
  otherUser: state.otherUser,
  deleteAppointment: state.deleteAppointment
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AppointmentList))



// WEBPACK FOOTER //
// ./src/js/components/pages/appointment/AppointmentList.js